var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "dc_customize" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-9 order-lg-2" }, [
                  _c("div", { attrs: { id: "series" } }, [
                    _c(
                      "div",
                      { staticClass: "mb-2", attrs: { id: "manufacturer" } },
                      [_vm._v("ドゥーマンズ株式会社")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "series_title2" }, [
                      _vm._v("パーソナルシェルフ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "kv" },
                      [
                        _c("dd-banner", {
                          ref: "ddBannerListRef",
                          attrs: {
                            swipeList: _vm.seriesList,
                            swiperOptions: _vm.categoryOptions,
                            horizontalMode: false
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(0)
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "series_content_title" }, [
                      _vm._v("おすすめの商品")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "recommend_wrap" },
                      [
                        _c("dd-product", {
                          ref: "ddCategoryListRef",
                          attrs: {
                            swipeList: _vm.productListReturn,
                            swiperOptions: _vm.productOptions,
                            horizontalMode: false
                          },
                          on: { clickImage: _vm.selectProduct }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "mt-5 series_content",
                      attrs: { id: "introduction1" }
                    },
                    [
                      _c("div", { staticClass: "series_title" }, [
                        _vm._v("パーソナルシェルフの特徴")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.contentList, function(content, index) {
                          return _c(
                            "div",
                            {
                              key: "series1_ct_" + index,
                              staticClass: "col-sm-6 mb-3 sc_main_content"
                            },
                            [
                              content.isVideo
                                ? [
                                    _c("iframe", {
                                      attrs: {
                                        width: "560",
                                        height: "225",
                                        src: content.url,
                                        title: "YouTube video player",
                                        frameborder: "0",
                                        allow:
                                          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                        allowfullscreen: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("div", [
                                        _vm._v(_vm._s(content.title))
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [_vm._v(_vm._s(content.body))])
                                    ])
                                  ]
                                : [
                                    _c("img", {
                                      attrs: { src: content.img, alt: "" }
                                    }),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("div", [
                                        _vm._v(_vm._s(content.title))
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [_vm._v(_vm._s(content.body))])
                                    ])
                                  ]
                            ],
                            2
                          )
                        })
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "mt-5 series_content",
                      attrs: { id: "introduction2" }
                    },
                    [
                      _c("div", { staticClass: "series_title" }, [
                        _vm._v(
                          "簡単な組立て方法の動画を見る 実証！驚きの速さ！驚きの精度"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.constructList2, function(content, index) {
                          return _c(
                            "div",
                            {
                              key: "series2_ct_" + index,
                              staticClass: "col-sm-6 mb-3 sc_main_content2"
                            },
                            [
                              content.isVideo
                                ? [
                                    _c("iframe", {
                                      attrs: {
                                        width: "560",
                                        height: "225",
                                        src: content.url,
                                        title: "YouTube video player",
                                        frameborder: "0",
                                        allow:
                                          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                        allowfullscreen: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("div", [
                                        _vm._v(_vm._s(content.title))
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [_vm._v(_vm._s(content.body))])
                                    ])
                                  ]
                                : [
                                    _c("img", {
                                      attrs: { src: content.img, alt: "" }
                                    }),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("div", [
                                        _vm._v(_vm._s(content.title))
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [_vm._v(_vm._s(content.body))])
                                    ])
                                  ]
                            ],
                            2
                          )
                        })
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-5", attrs: { id: "recommend" } },
                    [
                      _c("div", { staticClass: "series_content_title" }, [
                        _vm._v("新商品")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "recommend_wrap" },
                        [
                          _c("dd-product", {
                            ref: "ddCategoryListRef",
                            attrs: {
                              swipeList: _vm.productList,
                              swiperOptions: _vm.productOptions,
                              horizontalMode: false
                            },
                            on: { clickImage: _vm.selectProduct }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5", attrs: { id: "case" } }, [
                    _c("div", { staticClass: "series_content_title" }, [
                      _vm._v("施工事例")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "series_construct_list" },
                      _vm._l(_vm.constructList, function(construct, index) {
                        return _c(
                          "div",
                          {
                            key: "construct_" + index,
                            staticClass: "col-sm-3 mb-3 case_wrap"
                          },
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.selectProduct(construct)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: { src: construct.img, alt: "" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("h3", [_vm._v(_vm._s(construct.title))]),
                            _vm._v(" "),
                            _c("div", { staticClass: "product" }, [
                              _vm._v(_vm._s(construct.name))
                            ])
                          ]
                        )
                      })
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.route("DcSignUp")
                        }
                      }
                    },
                    [_vm._v("会員登録はこちら 〉〉")]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\r\n                ライフスタイルに合わせた自由なカスタマイズ。さまざまな空間にマッチ。"
      ),
      _c("br"),
      _vm._v(
        "\r\n                ドライバーなどの工具は一切不要。組立て後は部品が見えない完成度。"
      ),
      _c("br"),
      _vm._v(
        "\r\n                厚み30mmの強度、耐荷重性能。国内生産の高い品質管理基準。\r\n              "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bf44864", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf44864","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcSeriesPage.vue
// module id = null
// module chunks = 